import React from 'react';
import FinancialStatementTable from './FinancialStatementTable';
import GrowthAndReturnSummary from './GrowthAndReturnSummary';
import {
    buildProfitLossStatementRows,
    isProfitLossSectionCollapsible,
    isProfitLossStatementRowVisible,
} from '../config/profitLossStatementLayout';

const DEFAULT_EXPANDED = {
    sales: true,
    expenses: true,
    otherIncome: true,
    netProfit: true,
};

function ProfitLossStatementTable({
    data,
    growthAndReturn,
    orderedKeys = [],
    headers = [],
    onMetricInfo,
    onOpenChart,
}) {
    if (!data || Object.keys(data).length === 0) {
        return <p>No data available.</p>;
    }

    return (
        <>
            <FinancialStatementTable
                title="Profit & Loss Statement"
                data={data}
                orderedKeys={orderedKeys}
                headers={headers}
                onMetricInfo={onMetricInfo}
                onOpenChart={onOpenChart}
                buildRows={buildProfitLossStatementRows}
                isSectionCollapsible={isProfitLossSectionCollapsible}
                isRowVisible={isProfitLossStatementRowVisible}
                defaultExpanded={DEFAULT_EXPANDED}
                statementKey="profitAndLoss"
            />
            <GrowthAndReturnSummary
                profitAndLoss={data}
                growthAndReturn={growthAndReturn}
                onMetricInfo={onMetricInfo}
            />
        </>
    );
}

export default ProfitLossStatementTable;
